import { createStore, combineReducers, applyMiddleware } from 'redux';
import { blogPostsReducer } from './reducers/BlogPostReducers'
import { topNChartsPerYearLeaderboardReducer, topNChartsPerYearAndMonthLeaderboardReducer, topNNotechartArtistsLeaderboardReducer, topNPlaysLeaderboardReducer, topNScoresLeaderboardReducer, topNSongsPerYearLeaderboardReducer, topNSongsPerYearAndMonthLeaderboardReducer, userMaxDifficultyPassesOverTimeReducer, userPlaysOverTimeReducer, userScoresTakenLeaderboardReducer, userSeasonsProgressReducer, userRecommendedRivalsReducer, userNextScoresToTakeReducer, userPackProgressReducer, userPlaysPerTimeOfDayReducer, topNPlaysPerCountryLeaderboardReducer } from './reducers/StatsReducers'
import { logInReducer } from './reducers/LogInReducers'
import { exportUserGdprReportReducer, getProfileReducer, getUserCanExportGdprReportReducer, getUserCanRequestYearInReviewReportReducer, requestUserYearInReviewReportReducer } from './reducers/ProfileReducers'
import createSagaMiddleware from 'redux-saga'
import { rootSaga } from './sagas/RootSaga'

// The sagas middleware used to perform asynchronous operations against the server.
export const sagaMiddleware = createSagaMiddleware()

// The main store used for holding all application state.
export const store = createStore(
    combineReducers({
        blogPosts: blogPostsReducer,
        topNNotechartArtistsLeaderboard: topNNotechartArtistsLeaderboardReducer,
        topNPlaysLeaderboard: topNPlaysLeaderboardReducer,
        topNScoresLeaderboard: topNScoresLeaderboardReducer,
        topNChartsPerYearLeaderboard: topNChartsPerYearLeaderboardReducer,
        topNChartsPerYearAndMonthLeaderboard: topNChartsPerYearAndMonthLeaderboardReducer,
        topNSongsPerYearLeaderboard: topNSongsPerYearLeaderboardReducer,
        topNSongsPerYearAndMonthLeaderboard: topNSongsPerYearAndMonthLeaderboardReducer,
        logIn: logInReducer,
        profile: getProfileReducer,
        exportGdprReport: exportUserGdprReportReducer,
        canGdprExport: getUserCanExportGdprReportReducer,
        requestYearInReviewReport: requestUserYearInReviewReportReducer,
        canRequestYearInReviewReport: getUserCanRequestYearInReviewReportReducer,
        userPlaysOverTime: userPlaysOverTimeReducer,
        userPlaysPerTimeOfDay: userPlaysPerTimeOfDayReducer,
        userMaxDifficultyPassesOverTime: userMaxDifficultyPassesOverTimeReducer,
        userScoresTakenLeaderboard: userScoresTakenLeaderboardReducer,
        userSeasonsProgress: userSeasonsProgressReducer,
        userRecommendedRivals: userRecommendedRivalsReducer,
        userNextScoresToTake: userNextScoresToTakeReducer,
        userPackProgress: userPackProgressReducer,
        topNPlaysPerCountryLeaderboard: topNPlaysPerCountryLeaderboardReducer,
    }),
    applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);